/**
 * This type is copies from the buyProducts.ts file in order to avoid circular imports.
 * Before this, the circular import was: buyProducts.ts => formatProduct.ts => buyProduct.ts.
 *
 * DON"T USE THIS IMPORT!
 * import type { ProductType } from './buyProduct';
 */

export var formatProduct = function formatProduct(data, productType) {
  try {
    if (productType === 'membership') {
      return {
        id: data.originalId,
        productId: "MEMBERSHIP_".concat(data.originalId),
        name: data.name,
        category: "membership/".concat(data.tag),
        type: 'membership'
      };
    }
    if (productType === 'course') {
      var subcategory = data.subCategoryObj || data.subcategory;
      return {
        id: data.originalId,
        productId: "COURSE_".concat(data.originalId),
        name: data.title,
        category: "course/".concat(data.categoryObj.slug, "/").concat(subcategory.slug),
        type: 'course'
      };
    }
    if (productType === 'certification') {
      return {
        id: data.originalId,
        productId: "CERTIFICATION_".concat(data.originalId),
        name: data.title,
        category: "certification",
        type: 'certification'
      };
    }
    if (productType === 'customBundle') {
      return {
        id: data.originalId,
        productId: "CUSTOM_BUNDLE_".concat(data.originalId),
        name: data.name,
        category: "customBundle",
        type: 'custom_bundle'
      };
    }
    return {
      id: 0,
      productId: 'Error',
      name: 'Error',
      category: 'Error',
      type: 'error'
    };
  } catch (error) {
    console.error('Error while formating product');
    return {
      id: 0,
      productId: 'Error',
      name: 'Error',
      category: 'Error',
      type: 'error'
    };
  }
};